import React, { useRef, useState, useEffect } from "react";
import Apiservice from "../Apiservice";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";

const IncidentReportAdd = () => {
    const navigate = useNavigate();
    const [roleId, setRoleId] = useState(() => localStorage.getItem('role_id'));
    const [presentUserId, setPresentUserId] = useState(() => localStorage.getItem('user_id'));
    const [presentSiteId, setPresentSiteId] = useState(() => localStorage.getItem('siteId'));
    const [presentUserType, setPresentUserType] = useState(() => localStorage.getItem('userType'));
    const [presentNricOrFin, setPresentNricOrFin] = useState(() => localStorage.getItem('nricOrFin'));


    const [sites, setSites] = useState([]);
    const [incidentDate, setIncidentDate] = useState("");
    const [users, setUsers] = useState([]);

    const [userId, setUserId] = useState(0);

    const [siteId, setSiteId] = useState(0);
    const [siteName, setSiteName] = useState("");

    // Refs for single line inputs
    const informantNameRef = useRef("");
    const informantNRICRef = useRef("");
    const locationRef = useRef("");
    const placeRef = useRef("");
    const whatRef = useRef("");
    const whenRef = useRef("");
    const whereRef = useRef("");
    const whoRef = useRef("");
    const howRef = useRef("");
    const whyRef = useRef("");
    const securityImplicationsRef = useRef("");
    const vehicleRef = useRef("");
    const departmentRef = useRef("");

    // Date & time
    const [date, setDate] = useState("");
    const [time, setTime] = useState("");

    // Arrays
    const [whoWasInvolved, setWhoWasInvolved] = useState([]);
    const [nameAndRank, setNameAndRank] = useState([{ name: "", rank: "" }]);
    const [actionsTaken, setActionsTaken] = useState([""]);
    const [recommandation, setRecommandation] = useState([""]);

    const [errors, setErrors] = useState({})

    const toInvolvePersons = [
        "57 Peace Protection Command Centre",
        "Site Management",
        "24hours Central Monitoring Centre",
        "JTC Command Centre (Jurong island)",
        "SCDF",
        "Police",
        "AETOS (Jurong Island)",
        "Site Cleaner",
        "Site Technician",
        "Others",
    ];

    // Runs only once when component loads
    useEffect(() => {
        const now = new Date();

        const yyyy = now.getFullYear();
        const mm = String(now.getMonth() + 1).padStart(2, "0");
        const dd = String(now.getDate()).padStart(2, "0");

        setIncidentDate(`${yyyy}-${mm}-${dd}`);

        const hours = String(now.getHours()).padStart(2, "0");
        const minutes = String(now.getMinutes()).padStart(2, "0");

        setTime(`${hours}:${minutes}`);
    }, []);

    useEffect(() => {
        const fetchData = async () => {
            let data = { date: incidentDate };

            let result = await Apiservice.IncidentReportAddPage(data);

            if (result.success === true) {
                setSites(result.data);
            } else {
                alert(result.message);
            }
        };

        if (incidentDate) {   // avoid running before date is initialized
            fetchData();
        }

    }, [incidentDate]);   // <--- dynamic fetch based on changed date


    useEffect(() => {
        if (!sites.length) return;

        const selectedSite = sites.find(site => site.id == Number(presentSiteId));
        setSiteId(presentSiteId)

        if (selectedSite) {
            setSiteName(selectedSite.name);
        }
    }, [presentSiteId, sites]);




    useEffect(() => {
        const selectedSite = sites.find(site => site.id == siteId);
        if (selectedSite) {
            setUsers(selectedSite.users);
            setSiteName(selectedSite.name)
        }
    }, [siteId, sites]);


    // Handle involved persons checkbox
    const handleInvolvedChange = (person) => {
        setWhoWasInvolved((prev) =>
            prev.includes(person)
                ? prev.filter((p) => p !== person)
                : [...prev, person]
        );
    };

    // Handle name and rank dynamic fields
    const handleNameRankChange = (index, field, value) => {
        const updated = [...nameAndRank];
        updated[index][field] = value;
        setNameAndRank(updated);
    };

    const addNameRankRow = () => {
        setNameAndRank([...nameAndRank, { name: "", rank: "" }]);
    };

    // Handle actionsTaken & recommendation
    const handleArrayChange = (index, value, setter, arr) => {
        const updated = [...arr];
        updated[index] = value;
        setter(updated);
    };

    const addArrayRow = (setter, arr) => {
        setter([...arr, ""]);
    };

    const validateForm = () => {

        let firstError = "";

        const newErrors = {};

        if (presentUserType === 'floater' && !presentNricOrFin) {
            firstError = "NRIC OR FIN Missing";
            newErrors.nric = "NRIC OR FIN Missing";
        }

        const finalUserId = roleId == 1 ? userId : presentUserId;
        const finalSiteId = roleId == 1 ? siteId : presentSiteId;

        if (presentUserType?.toLowerCase().trim() === 'normal') {
            if (!finalUserId) {
                newErrors.userId = "User is required";
                firstError ||= "User is required";
            }
        }

        if (!finalSiteId) {
            newErrors.siteId = "Site is required";
            firstError ||= "Site is required";
        }

        if (!informantNameRef.current.value.trim()) {
            newErrors.informantName = "Informant name is required";
            firstError ||= "Informant name is required";
        }

        if (!informantNRICRef.current.value.trim()) {
            newErrors.informantNRIC = "Informant NRIC is required";
            firstError ||= "Informant NRIC is required";
        }

        if (!placeRef.current.value.trim()) {
            newErrors.place = "Place of Incident is required";
            firstError ||= "Place of Incident is required";
        }

        if (!locationRef.current.value.trim()) {
            newErrors.location = "Location of Incident is required";
            firstError ||= "Location of Incident is required";
        }

        if (!incidentDate) {
            newErrors.incidentDate = "Incident date is required";
            firstError ||= "Incident date is required";
        }

        if (!time) {
            newErrors.time = "Incident Time is required";
            firstError ||= "Incident Time is required";
        }

        if (!whatRef.current.value.trim()) {
            newErrors.what = "What is required";
            firstError ||= "What is required";
        }

        if (!whenRef.current.value.trim()) {
            newErrors.when = "When is required";
            firstError ||= "When is required";
        }

        if (!whereRef.current.value.trim()) {
            newErrors.where = "Where is required";
            firstError ||= "Where is required";
        }

        if (!whoRef.current.value.trim()) {
            newErrors.who = "Who is required";
            firstError ||= "Who is required";
        }

        if (!howRef.current.value.trim()) {
            newErrors.how = "How is required";
            firstError ||= "How is required";
        }

        if (!whyRef.current.value.trim()) {
            newErrors.why = "Why is required";
            firstError ||= "Why is required";
        }

        setErrors(newErrors);

        return {
            isValid: Object.keys(newErrors).length === 0,
            message: firstError
        };
    };



    const handleAdd = async () => {
        const validation = validateForm();

        if (!validation.isValid) {
            Swal.fire({
                title: "Validation Error",
                text: validation.message,
                icon: "warning",
            });
            return;
        }

        // Common Data
        let data = {
            presentUserType:presentUserType,
            siteId: roleId == 1 ? siteId : presentSiteId,
            informantName: informantNameRef.current?.value || "",
            informantNRIC: informantNRICRef.current?.value || "",
            place: placeRef.current?.value || "",
            location: locationRef.current?.value || "",
            date: incidentDate,
            time: time,
            what: whatRef.current?.value || "",
            when: whenRef.current?.value || "",
            where: whereRef.current?.value || "",
            who: whoRef.current?.value || "",
            how: howRef.current?.value || "",
            why: whyRef.current?.value || "",
            securityImplications: securityImplicationsRef.current?.value || "",
            vehicleNumber: vehicleRef.current?.value || "",
            department: departmentRef.current?.value || "",
            whoWasInvolved,
            nameAndRank,
            actionsTaken,
            recommandation,
        };

        // Add type specific field
        if (presentUserType === 'normal') {
            data.userId = roleId == 1 ? userId : presentUserId;
        }

        if (presentUserType === 'floater') {
            data.nricOrFin = presentNricOrFin;
        }

        let result = await Apiservice.IncidentReportAdd(data);
        if (result.success) {
            Swal.fire({
                title: "Incident Report Added!",
                text: result.message,
                icon: "success",
            });
            navigate('/incidentreport');
        } else {
            Swal.fire({
                title: "Error",
                text: result.message,
                icon: "error",
            });
        }
    };

    return (
        <div className="container-fluid card shadow ">
            <h3 className="mb-3 text-center">Incident Report Add</h3>
            <div className="row card shadow p-md-2 m-md-2 p-1 m-1">
                <div className="row">
                    <div className="col"><u>PART A : INCIDENT DETAILS</u></div>
                </div>
                <div className="row mb-2">
                    <div className="col-md-6 col-12">
                        <div className="row">
                            <div className="col-4 col-md">Site </div>
                            <div className="col">

                                {
                                    roleId == 1 ? (
                                        <>
                                            <select
                                                className={`form-select form-select-sm ${errors.siteId ? "is-invalid" : ""}`}
                                                value={siteId}
                                                onChange={(e) => setSiteId(e.target.value)}
                                            >
                                                <option value="">-- Select Site --</option>

                                                {sites.length > 0 ? (
                                                    sites.map((site) => (
                                                        <option value={site.id} key={site.id}>
                                                            {site.name}
                                                        </option>
                                                    ))
                                                ) : (
                                                    <option disabled>No Sites Found</option>
                                                )}
                                            </select>

                                            {errors.siteId && (
                                                <div className="invalid-feedback">{errors.siteId}</div>
                                            )}
                                        </>
                                    ) : (
                                        <>
                                            <input
                                                type="text"
                                                value={siteName}
                                                readOnly
                                                className={`form-control form-control-sm ${errors.siteId ? "is-invalid" : ""}`}
                                            />

                                            {errors.siteId && (
                                                <div className="invalid-feedback">{errors.siteId}</div>
                                            )}
                                        </>
                                    )
                                }


                            </div>

                        </div>
                    </div>
                    <div className="col-md-3 col-12">
                        <div className="row">
                            <div className="col-4 col-md">Date </div>
                            <div className="col">
                                <input
                                    type="date"
                                    className={`form-control form-control-sm ${errors.incidentDate ? "is-invalid" : ""}`}
                                    value={incidentDate}
                                    max={new Date().toISOString().split("T")[0]}   // <-- Prevent future dates
                                    onChange={(e) => {
                                        if (roleId == 1) {
                                            setIncidentDate(e.target.value);
                                        }
                                    }}
                                    disabled={roleId != 1}   // <--- IMPORTANT
                                />
                                {errors.incidentDate && (
                                    <div className="invalid-feedback">{errors.incidentDate}</div>
                                )}
                            </div>

                        </div>
                    </div>
                    {
                        roleId == 1 && (
                            <div className="col-md-3 col-12">
                                <div className="row">
                                    <div className="col-4 col-md-3">Staff </div>
                                    <div className="col">
                                        <select
                                            className={`form-select form-select-sm ${errors.siteId ? "is-invalid" : ""}`}
                                            value={userId || ""}
                                            onChange={(e) => setUserId(e.target.value)}
                                        >
                                            {users.length > 0 ? (
                                                <>
                                                    <option value="">-- Select User --</option>
                                                    {users.map((user) => (
                                                        <option value={user.id} key={user.id}>
                                                            {user.firstName} {user.lastName}
                                                        </option>
                                                    ))}
                                                </>
                                            ) : (
                                                <option value="">No Staffs Found</option>
                                            )}
                                        </select>

                                        {errors.userId && (
                                            <div className="invalid-feedback">{errors.userId}</div>
                                        )}
                                    </div>

                                </div>
                            </div>
                        )
                    }
                </div>
                <div className="row mb-2">
                    <div className="col-md col-12">
                        <div className="row">
                            <div className="col-4 col-md">Place Of Incident</div>
                            <div className="col">
                                <input type="text" name="" id="" ref={placeRef} className={`form-control form-control-sm ${errors.placeRef ? "is-invalid" : ""}`} />
                                {errors.placeRef && (
                                    <div className="invalid-feedback">{errors.placeRef}</div>
                                )}
                            </div>
                        </div>
                    </div>
                    <div className="col-md col-12">
                        <div className="row">
                            <div className="col-4 col-md">Location</div>
                            <div className="col">
                                <input type="text" name="" id="" ref={locationRef} className={`form-control form-control-sm ${errors.locationRef ? "is-invalid" : ""}`} />
                                {errors.locationRef && (
                                    <div className="invalid-feedback">{errors.locationRef}</div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row mb-2">
                    <div className="col-md col-12">
                        <div className="row">
                            <div className="col-4 col-md">Name of Informant</div>
                            <div className="col">
                                <input type="text" name="" id="" ref={informantNameRef} className="form-control form-control-sm" />
                            </div>
                        </div>
                    </div>
                    <div className="col-md col-12">
                        <div className="row">
                            <div className="col-4 col-md">Informant NRIC</div>
                            <div className="col">
                                <input type="text" name="" id="" ref={informantNRICRef} className="form-control form-control-sm" />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row mb-2">
                    <div className="col">
                        <div className="row">
                            <div className="col-md-3 col-4">Time of incident</div>
                            <div className="col">
                                <input type="time" name="" id="" value={time}
                                    onChange={(e) => setTime(e.target.value)}
                                    className={`form-control form-control-sm ${errors.time ? "is-invalid" : ""}`} />
                                {errors.time && (
                                    <div className="invalid-feedback">{errors.time}</div>
                                )}
                            </div>
                        </div>
                    </div>

                </div>

            </div>



            {/* Sections */}
            {[
                { label: <u>PART B : What Happened?</u>, ref: whatRef },
                { label: <u>PART C : When Did It Happen?</u>, ref: whenRef },
                { label: <u>PART D : Where Did It Happen?</u>, ref: whereRef },
                { label: <u>PART E : Who Was Involved?</u>, ref: whoRef },
                { label: <u>PART F : How Did It Happen?</u>, ref: howRef },
                { label: <u>PART G : Why Did It Happen?</u>, ref: whyRef },
                {
                    label: <u>`PART H : IS THERE ANY SECURITY IMPLICATION DUE
                        TO THE INCIDENT?(SECURITY INVOLVEMENT) IF YES, WHAT WERE THE ACTION TAKEN.
                        PLEASE EXPLAIN`</u>, ref: securityImplicationsRef
                },
            ].map((f, i) => (
                <div className="row mb-2 card shadow p-2 m-2" key={i}>
                    <div className="row">
                        <div className="col">{f.label}</div>
                    </div>

                    <div className="row">
                        <div className="col">
                            <textarea
                                ref={f.ref}
                                rows={5}
                                style={{ resize: "vertical" }}
                                className={`form-control form-control-sm ${errors[f.ref] ? "is-invalid" : ""
                                    }`}
                            />

                            {errors[f.ref] && (
                                <div className="invalid-feedback">
                                    {errors[f.ref]}
                                </div>
                            )}
                        </div>
                    </div>

                </div>
            ))}

            {/* Checkbox List */}
            <div className="row mb-3 card shadow p-2 m-2">
                <u>PART I : WHO WAS INVOLVED</u>
                <div className="row">
                    {toInvolvePersons.map((p, i) => (
                        <div className="col-6" key={i}>
                            <label>
                                <input
                                    type="checkbox"
                                    className="form-check-input me-1"
                                    checked={whoWasInvolved.includes(p)}
                                    onChange={() => handleInvolvedChange(p)}
                                />
                                {p}
                            </label>
                        </div>
                    ))}
                </div>
            </div>

            {/* Name & Rank */}
            <div className="row mb-3 card shadow p-2 m-2">
                <u>PART J : PARTICULARS OF "WHO WAS INVOLVED" (PART I)</u>
                <table className="table table-borderless">
                    <tbody>
                        <tr>
                            <td style={{ width: "200px" }}>Name & RANK (If Any)</td>
                            <td>
                                {nameAndRank.map((nr, i) => (
                                    <div className="row mb-2" key={i}>
                                        <div className="col">
                                            <input
                                                placeholder="Name"
                                                value={nr.name}
                                                onChange={(e) =>
                                                    handleNameRankChange(i, "name", e.target.value)
                                                }
                                                className="form-control form-control-sm"
                                            />
                                        </div>
                                        <div className="col">
                                            <input
                                                placeholder="Rank"
                                                value={nr.rank}
                                                onChange={(e) =>
                                                    handleNameRankChange(i, "rank", e.target.value)
                                                }
                                                className="form-control form-control-sm"
                                            />
                                        </div>
                                    </div>
                                ))}
                                <button
                                    className="btn btn-sm btn-secondary mt-1"
                                    onClick={addNameRankRow}
                                >
                                    + Add Row
                                </button>
                            </td>
                        </tr>

                        <tr>
                            <td>Vehicle Number</td>
                            <td>
                                <input ref={vehicleRef} className="form-control form-control-sm" />
                            </td>
                        </tr>

                        <tr>
                            <td>Department</td>
                            <td>
                                <input ref={departmentRef} className="form-control form-control-sm" />
                            </td>
                        </tr>

                        <tr>
                            <td>Actions Taken</td>
                            <td>
                                {actionsTaken.map((a, i) => (
                                    <div className="row mb-2" key={i}>
                                        <div className="col">
                                            <input
                                                value={a}
                                                onChange={(e) =>
                                                    handleArrayChange(
                                                        i,
                                                        e.target.value,
                                                        setActionsTaken,
                                                        actionsTaken
                                                    )
                                                }
                                                className="form-control form-control-sm"
                                            />
                                        </div>
                                    </div>
                                ))}
                                <button
                                    className="btn btn-sm btn-secondary mt-1"
                                    onClick={() =>
                                        addArrayRow(setActionsTaken, actionsTaken)
                                    }
                                >
                                    + Add Action
                                </button>
                            </td>
                        </tr>

                        <tr>
                            <td>Recommendation</td>
                            <td>
                                {recommandation.map((r, i) => (
                                    <div className="row mb-2" key={i}>
                                        <div className="col">
                                            <input
                                                value={r}
                                                onChange={(e) =>
                                                    handleArrayChange(
                                                        i,
                                                        e.target.value,
                                                        setRecommandation,
                                                        recommandation
                                                    )
                                                }
                                                className="form-control form-control-sm"
                                            />
                                        </div>
                                    </div>
                                ))}
                                <button
                                    className="btn btn-sm btn-secondary mt-1"
                                    onClick={() =>
                                        addArrayRow(setRecommandation, recommandation)
                                    }
                                >
                                    + Add Recommendation
                                </button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div className="row mb-3 p-2 m-2">
                <div className="col text-center">
                    <button className="btn btn-primary col-md-8" onClick={handleAdd}>
                        Submit Report
                    </button>
                </div>
            </div>



        </div>
    );
};

export default IncidentReportAdd;
